import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import AlertCard from './AlertCard';

const TerminalDetailsAlertsCardPanel = ({ terminalAlertsQuery }) => (
  <Box
    sx={{
      columnGap: 3,
      display: 'grid',
      gridTemplateColumns: {
        md: 'repeat(2, minmax(320px,580px))',
        xs: '1fr',
      },
      gridTemplateRows: 'repeat(auto-fill, auto)',
      justifyItems: 'center',
      rowGap: { md: 3, xs: 1 },
      scrollMarginTop: '276px',
    }}
  >
    {terminalAlertsQuery.map((alert, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <AlertCard alertData={alert} key={index} />
    ))}
  </Box>
);

TerminalDetailsAlertsCardPanel.propTypes = {
  terminalAlertsQuery: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default TerminalDetailsAlertsCardPanel;
